import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api, { fileUrl } from '../lib/api';
import { Radio } from 'lucide-react';

const avatarFallback = (name) =>
  `https://ui-avatars.com/api/?name=${encodeURIComponent(name || 'U')}&background=FFB000&color=000&bold=true`;

export default function LiveNow() {
  const [streams, setStreams] = useState([]);

  useEffect(() => {
    let cancelled = false;
    const load = () => {
      api.get('/live/active').then(r => { if (!cancelled) setStreams(r.data); }).catch(() => {});
    };
    load();
    const t = setInterval(load, 15000);
    return () => { cancelled = true; clearInterval(t); };
  }, []);

  if (!streams.length) return null;

  return (
    <div className="post-card p-4 mb-6" data-testid="live-now-panel">
      <div className="flex items-center gap-2 mb-3">
        <span className="w-2 h-2 rounded-full bg-[#EF4444] animate-pulse" />
        <div className="text-xs uppercase tracking-[0.3em] font-bold text-[#EF4444]">Live now</div>
      </div>
      <div className="space-y-2">
        {streams.slice(0, 5).map(s => (
          <Link
            key={s.stream_id}
            to={`/live/${s.stream_id}`}
            className="flex items-center gap-3 p-2 rounded-lg hover:bg-white/5 transition-colors group"
            data-testid={`live-now-${s.stream_id}`}
          >
            <div className="relative flex-shrink-0">
              <img
                src={s.avatar_path ? fileUrl(s.avatar_path) : avatarFallback(s.name)}
                alt=""
                className="w-10 h-10 rounded-full object-cover border border-[#EF4444]/60"
              />
              <span className="absolute -bottom-0.5 -right-0.5 bg-[#EF4444] text-white text-[8px] font-black px-1 py-0.5 rounded uppercase tracking-widest">Live</span>
            </div>
            <div className="min-w-0 flex-1">
              <div className="text-white text-sm font-bold truncate group-hover:text-[#FFB000] transition-colors">{s.title}</div>
              <div className="text-[#A1A1AA] text-xs truncate">@{s.username} · {s.viewer_count} listening</div>
            </div>
            <Radio size={14} className="text-[#EF4444] flex-shrink-0" />
          </Link>
        ))}
      </div>
    </div>
  );
}
